/* eslint-disable camelcase */

import { notifyError } from "common/utils/app-monitoring/notify";
import { NETWORK_ERROR_PATTERNS } from "common/utils/app-monitoring/network-error-patterns";

export { NETWORK_ERROR_PATTERNS };

const isNetworkError = value => {
  if (!value || typeof value !== "string") return false;
  return NETWORK_ERROR_PATTERNS.some(pattern => pattern.test(value));
};

/**
 * Logs an upload artwork error to app monitoring.
 *
 * @param {object} payload - The payload containing error information.
 * @param {string} payload.error_message - The error message.
 * @param {string} payload.error - The error description.
 * @param {string} payload.handledError - The error is handled by backend validation.
 * @param {string} payload.uploadError - The error description for the upload.
 */
// eslint-disable-next-line import/prefer-default-export
export const logUploadError = payload => {
  const { error_message, error, handledError, uploadError, errorResponse } = payload;

  // Known errors that are not worth reporting
  // i.e. "Network Error" is not code related, but a network issue
  const knownErrors = ["Something went wrong while processing your artwork", "Network Error"];

  const isTimeoutError = errorResponse?.error_type === "timeout_error";

  if (
    knownErrors.includes(error) ||
    uploadError === "Processing error" ||
    handledError ||
    isTimeoutError ||
    isNetworkError(error) ||
    isNetworkError(error_message)
  )
    return;

  notifyError("Upload artwork error", {
    params: {
      error_message,
      error,
      uploadError,
      errorResponse
    }
  });
};
/* eslint-enable camelcase */
